import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { post } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import {
    DISMISS_BUTTON_CLASS,
    DISMISS_URL,
    I18_DISMISS,
    GTM_DISMISS_INSTRUCTION,
} from './constants/constants';
import {
    useRemoveInstructionCardDispatch,
} from '~SpectateStore/hooks/userHooks';

import './styles/dismissButton.scss';


const DismissButton = ({ type, gtmAttribute }) => {
    const [ t ] = useTranslation();
    const removeInstructionCard = useRemoveInstructionCardDispatch();

    const dismissCard = async () => {
        const INSTRUCTION_CARD_DISMISS = `${DISMISS_URL}${type}`;
        const url = buildSpectateUrl(INSTRUCTION_CARD_DISMISS);
        const response = await post(url);

        if (response.ok) {
            removeInstructionCard(type);
        }
    };

    return (
        <button
            className={DISMISS_BUTTON_CLASS}
            onClick={dismissCard}
            data-spectate-product={`${gtmAttribute}${GTM_DISMISS_INSTRUCTION}`}>
                {t(I18_DISMISS)}
        </button>
    );
};

DismissButton.propTypes = {
    gtmAttribute: PropTypes.string,
    type: PropTypes.string.isRequired,
};

DismissButton.defaultProps = {
    gtmAttribute: '',
};

export default DismissButton;
